export default __webpack_public_path__ + "static/media/figo-logo.d8237f4c.svg";